var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCreationPlus = function SvgCreationPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    x: 1,
    y: 1,
    fill: "#fff",
    rx: 25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#98A2B3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.381,
    d: "M26 17.667v16.666M17.667 26h16.666"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    x: 1,
    y: 1,
    stroke: "#D0D5DD",
    strokeDasharray: "1.79 5.36",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.786,
    rx: 25
  })));
};
export { SvgCreationPlus as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTIiIGhlaWdodD0iNTIiIHZpZXdCb3g9IjAgMCA1MiA1MiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMSIgeT0iMSIgd2lkdGg9IjUwIiBoZWlnaHQ9IjUwIiByeD0iMjUiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0yNi4wMDAxIDE3LjY2NjdWMzQuMzMzNE0xNy42NjY3IDI2LjAwMDFIMzQuMzMzNCIgc3Ryb2tlPSIjOThBMkIzIiBzdHJva2Utd2lkdGg9IjIuMzgwOTUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cmVjdCB4PSIxIiB5PSIxIiB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIHJ4PSIyNSIgc3Ryb2tlPSIjRDBENUREIiBzdHJva2Utd2lkdGg9IjEuNzg1NzEiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLWRhc2hhcnJheT0iMS43OSA1LjM2Ii8+Cjwvc3ZnPgoK";